import Vue from 'vue'
import vuetify from './app/plugins/vuetify'
import VueMask from 'v-mask'
import router from './app/router'
import store from './app/store'

Vue.use(VueMask)

//Vue.mixin(spinner)

// import VuePhoneNumberInput from 'vue-phone-number-input';
// import 'vue-phone-number-input/dist/vue-phone-number-input.css';

// Vue.component('vue-phone-number-input', VuePhoneNumberInput);
import('./app/helpers/date');
Vue.component('app', require('./app/App.vue').default);

Vue.config.productionTip = false
const app = new Vue({
    router,
    store,
    vuetify,
}).$mount('#app')
